export default __webpack_public_path__ + "static/research-datagaps-9ca6cc060008b2f598f6554189cd0015.png";